// extracted by mini-css-extract-plugin
export default {"cardBodyHeadingLabel":"workflowSummary_cardBodyHeadingLabel__-2kZ2"};